import { useState, useEffect } from 'react';
import getContent from 'lib/getContent';
import { page } from 'lib/track';
import { CONTENT_TYPES } from '../constants';

export const useWeekData = (slug, product, authToken, user) => {
  const [contentItem, setContentItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWeek = async () => {
      try {
        setLoading(true);
        const res = await getContent(slug, product, authToken);

        const video = res.Children.find(item => item.type === CONTENT_TYPES.VIDEO);
        const checklist = res.Children.find(item => item.type === CONTENT_TYPES.CHECKLIST);
        const recipesList = res.Children.find(item => item.type === CONTENT_TYPES.RECIPES_LIST);
        const resourcesList = res.Children.find(item => item.type === CONTENT_TYPES.RESOURCES_LIST);

        const userAnalytics = {
          service: 'weekly_guide',
          content_id: res.id,
          slug: res.slug,
          title: res.title,
          uuid: user?.UUID
        };

        setContentItem({
          ...res,
          video,
          checklist,
          recipesList,
          resourcesList,
          userAnalytics
        });

        page('weekly guide', {
          service: 'weekly_guide',
          contentId: res.id,
          slug: res.slug,
          title: res.title,
          uuid: user?.UUID
        });
      } catch (e) {
        console.log('error getting Weeks in Weeks Page', e.message);
        setError(e);
      } finally {
        setLoading(false);
      }
    };

    if (slug && product && authToken) {
      fetchWeek();
    }
  }, [slug, product, authToken, user?.UUID]);

  return { contentItem, loading, error };
};
